export default {
    "choose-language": {
        "choose-a-language": "Choose a Language",
    },
};
